import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getTokenDefinition, isValidChainId, getValidChainId, } from "@bracket/chainography";
import { burn as burnBrktETH, } from "@bracket/contractor-next/brktETH";
import { isBlockHash, type TokenIdentifier, } from "@bracket/types";
import { amountToBigInt } from "../helpers";
import type { RedeemProps, RedeemResult, } from "./redeem";


/**
 * Executes a burn operation to convert BRKTETH back to the underlying token
 * @param {RedeemProps} props - The burn parameters
 * @param {TokenIdentifier} props.token - The token identifier to receive after burning
 * @param {AmountString} props.amount - The expected amount of token to receive
 * @param {AmountString} props.brkt - The amount of BRKTETH to burn
 * @returns {Promise<RedeemResult>} Result containing transaction hash or error
 * @throws {Error} If the chain ID is invalid
 */
export const burn = async ({
  token,
  amount,
  brkt,
}: RedeemProps): Promise<RedeemResult> => {

  const chainId = getChainId(config);
  if(!isValidChainId(chainId))
    throw new Error("burn.resolvers.burn received an invalid chainId");

  const tokenInDefinition = getTokenDefinition(token);
  const amountOutBigInt = amountToBigInt(amount, tokenInDefinition);
  const brktOutBigInt = amountToBigInt(brkt, getTokenDefinition({ symbol: "BRKTETH", chainId: getValidChainId(config), }));

  const hash = await burnBrktETH({
		token: tokenInDefinition,
		amount: brktOutBigInt,
		minColAmount: amountOutBigInt,
		config,
	})
  .catch(err => {

    console.warn(`@bracket/platform/client/store/slices/swap/resolvers/burn has failed - ${err instanceof Error ? err.message : "unknown error"}`);
    return null;
  });

  if(isBlockHash(hash)) {
    return {
      hash,
      error: undefined,
    };
  }

  return {
    hash: null,
    error: new Error("burn.resolvers.burn has failed"),
  };
};
